var getRems = function getRems(pixels) {
  return "".concat(+pixels / 16, "rem");
};

export default getRems;
//# sourceMappingURL=getRems.js.map